import { render } from "./RadioTabletFormComponent.vue?vue&type=template&id=73f22986"
import script from "./RadioTabletFormComponent.vue?vue&type=script&lang=js"
export * from "./RadioTabletFormComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__